import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from '@techstyle/react-intl';
import { ProductType } from '@techstyle/react-products';
import { useProductContext } from '../ProductContext';
import useTabIndex from '../useTabIndex';
var Wrapper = styled.span.withConfig({
  displayName: "MoreColorsLabel__Wrapper",
  componentId: "sc-16muavn-0"
})(["\n  display: inline-block;\n  font-size: 12px;\n  color: #4d74a0;\n\n  a:link &,\n  &:link {\n    text-decoration: underline;\n  }\n"]);
var eligibleProductTypes = new Set([ProductType.NORMAL, ProductType.MEMBERSHIP_REWARD_POINTS_ITEM, ProductType.BUNDLE_COMPONENT]);
var MoreColorsLabel = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var _product$relatedProdu;

  var className = _ref.className,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "product_cell.more_colors_label",
    defaultMessage: "+ more colors"
  }) : _ref$children,
      href = _ref.href,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? href ? 'a' : undefined : _ref$as,
      productFromProps = _ref.product,
      tabIndex = _ref.tabIndex,
      _ref$maxProductCount = _ref.maxProductCount,
      maxProductCount = _ref$maxProductCount === void 0 ? 1 : _ref$maxProductCount,
      rest = _objectWithoutProperties(_ref, ["className", "children", "href", "as", "product", "tabIndex", "maxProductCount"]);

  var productFromContext = useProductContext();
  var product = productFromProps || productFromContext;
  var relatedProducts = (product === null || product === void 0 ? void 0 : (_product$relatedProdu = product.relatedProductIdObjectList) === null || _product$relatedProdu === void 0 ? void 0 : _product$relatedProdu.filter(product => product.isAvailable && !product.isSelf)) || [];
  var isEligible = eligibleProductTypes.has(product.productTypeId);
  tabIndex = useTabIndex(tabIndex);
  return isEligible && relatedProducts.length >= maxProductCount ? /*#__PURE__*/React.createElement(Wrapper, _extends({
    as: as,
    className: className,
    "data-autotag": "grid-product-more-colors",
    href: href,
    tabIndex: tabIndex,
    ref: ref
  }, rest), children) : null;
});
MoreColorsLabel.displayName = 'MoreColorsLabel';
MoreColorsLabel.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  maxProductCount: PropTypes.number,
  product: PropTypes.object,
  tabIndex: PropTypes.number
};
export default MoreColorsLabel;